import { render, staticRenderFns } from "./FormSaleReturn.vue?vue&type=template&id=0a7c6010"
import script from "./FormSaleReturn.vue?vue&type=script&lang=js"
export * from "./FormSaleReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports